module.exports = {"name":"Facebook Chat","menu_entries":{"chat":"Facebook Chat"},"label":{"no_accounts_available":"No facebook accounts available"}}